<template lang="pug">
	.iab-categories-selection
		.header-data
			h2.content-block.header {{$tCaption('Audience interests selection')}}
		.widgets-area.segment
			DxResponsiveBox(:screen-by-width="screen", single-column-screen="xs sm")
				DxRow(:ratio="1")
				DxCol(:ratio="1")
				DxCol(:ratio="2")
				DxItem()
					DxLocation(:row="0", :col="0")
					template(v-slot:default)
						.widgets
							.widget
								.data-vertical
									DxTreeList.iab-list(
										ref="iabCategories"
										:data-source="categories"
										:show-borders="false"
										:column-auto-width="true"
										:word-wrap-enabled="true"
										:expanded-row-keys="expandedRowKeys"
										:selected-row-keys="treeGridSelectedKeys"
										key-expr="UniqueID"
										parent-id-expr="ParentID"
										@selectionChanged="selectionChanged"
									)
										DxSearchPanel(:visible="true", :width="335", :placeholder="$tCaption('Start typing or scroll through interests below')")
										DxHeaderFilter(:visible="true")
										DxSelection(mode="multiple", :recursive="true")
										DxColumnChooser(:enabled="false")
										DxColumn(:width="400", data-field="Name")

				DxItem()
					DxLocation(:row="0", :col="1")
					template(v-slot:default)
						.widgets
							.widget
								.header {{$tCaption('Selected Interests')}}
								.data-horizontal
									template(v-for="item in selectedCategories")
										DxButton.iab-item(:text="item.Name", icon="close", @click="$refs.iabCategories.instance.deselectRows(item.UniqueID)", type="default")
</template>

<script>
	import axios from 'axios';
	import VueTypes from 'vue-types';
	import {
		DxTreeList,
		DxColumn,
		DxColumnChooser,
		DxHeaderFilter,
		DxSearchPanel,
		DxSelection,
		DxLookup
	} from 'devextreme-vue/tree-list';
	import DxButton from 'devextreme-vue/button';
	import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
	import Data from 'app-core/Data';

	export default {
		translationCategory: 'proposal.IABCategoriesSelection',
		name: 'iab-categories-selection',
		components: {
			DxButton,
			DxResponsiveBox,
			DxItem,
			DxLocation,
			DxCol,
			DxRow,
			DxTreeList,
			DxColumn,
			DxColumnChooser,
			DxHeaderFilter,
			DxSearchPanel,
			DxSelection,
			DxLookup
		},
		props: {
			data: VueTypes.object.def({}),
			iabCategories: VueTypes.array.def([])
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				categories: [],
				expandedRowKeys: [],
				selectedRowKeys: [],
				treeGridSelectedKeys: [],
				loaded: false
			};
		},
		computed: {
			selectedCategories() {
				return this.categories.filter(f => this.selectedRowKeys.indexOf(f.UniqueID) > -1);
			}
		},
		mounted() {
			if (__DEBUG__)
				console.log('IAB categories selection mounted', this);
			Data.loadCategories().then(r => {
				if (this._isDestroyed) return;
				if (__DEBUG__)
					console.log('Categories loaded', r);
				this.categories = r;
				this.treeGridSelectedKeys = this.iabCategories.map(f => f.UniqueID);
				this.loaded = true;
			});
		},
		methods: {
			selectionChanged(e) {
				if (!this.loaded) return;
				if (__DEBUG__)
					console.log('Selection changed', e);
				this.selectedRowKeys = this.$refs.iabCategories.instance.getSelectedRowKeys('all').map(f => f.UniqueID || f);
				this.data.iabCategories = this.selectedRowKeys;
			}
		}
	};
</script>
<style lang='scss'>
	.iab-categories-selection {
		@import "main/themes/generated/variables.base.scss";

		.iab-list {
			height: calc(100vh - 515px);
			min-height: 400px;
		}

		.iab-item {
			background: $base-accent;
			color: $base-bg;
			border-radius: 4px;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}
</style>
